<template>
  <select-item :validator="validator"
    :items="filteredRoles"
    placeholder="Select a Role"
    placeholderEmpty="No roles found"
    :isLoading="isLoading" />
</template>

<script>
import SelectItem from './SelectItem.vue';
import { mapGetters } from 'vuex';
import config from '../../config';

export default {
  name: 'SelectRole',
  components: {
    SelectItem
  },
  props: {
    validator: Object
  },
  data() {
    return {
      isLoading: false
    }
  },
  created() {
    if (!this.roles) {
      this.fetchRoles();
    }
  },
  methods: {
    async fetchRoles() {
      this.isLoading = true;
      await this.$store.dispatch('user/fetchRoles');
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('user', ['roles', 'isSuperUser']),
    ...mapGetters('organization', ['selectedOrganization']),
    filteredRoles() {
      let roles = this.roles;
      if (this.isSuperUser && this.selectedOrganization.id != config.ZIPERASE_ID) {
        roles = this.roles.filter(role => {
          return role.id != config.SUPERUSER &&
            role.id != config.STAFF_USER;
        });
      }
      return roles.map(role => {
        return {
          id: role.id,
          name: role.name
        };
      });
    }
  }
}
</script>

